//
//
//
//
import SanityMuxVideo from '~/components/sanity/SanityMuxVideo.vue';
import SanityInlineImage from '~/components/sanity/SanityInlineImage.vue';
import SanityLink from '~/components/sanity/SanityLink.vue';
import SanityColoredText from '~/components/sanity/SanityColoredText.vue';
export default {
  name: 'SanityBlockContent',
  props: {
    blocks: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      serializers: {
        types: {
          image: SanityInlineImage,
          muxVideo: SanityMuxVideo
        },
        marks: {
          link: SanityLink,
          color: SanityColoredText,
          underline: 'u',
          sup: 'sup',
          inlineImage: SanityInlineImage
        },
        list: {
          bullet: 'ul',
          number: 'ol'
        }
      }
    };
  }

};